import * as Yup from "yup";

export const vehicleInfoSchema = Yup.object().shape({
  make: Yup.string().required("Must Enter Make"),
  model: Yup.string().required("Must Enter Model"),
  color: Yup.string().required("Must Enter Color"),
});